

















import { Prop, Component, Vue } from "vue-property-decorator";
import { Fillers } from "../../types/NewResults";
@Component({
  components: {}
})
export default class Filler extends Vue {
  @Prop() private fillers!: Fillers;
}
